module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "pix"
    }
  }), _vm._v(" "), _c('em', [_vm._v("The valley spirit never dies;")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("It is the woman, primal mother.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Her gateway is the root of heaven and earth.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("It is like a veil barely seen.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Use it; it will never fail.")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "right"
  }, [_vm._v("—L"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("AO")]), _vm._v(" T"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("SU")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('em', [_vm._v("Don't go opening your mouth about things")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("that's none of your business. Hush up.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Hold your mud.")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "right"
  }, [_vm._v("—D"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("AISY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1160f805","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0